import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiCallsService } from 'src/app/shared/services/network/api-calls.service';
import { api } from 'src/app/utils/endpoints';
import { confirmationMessages } from 'src/app/utils/popup-messages';
import { ConfirmationPopupComponent } from '../../popups/confirmation-popup/confirmation-popup.component';
import { ToastrService } from 'ngx-toastr';
import { CommonDataSharingService } from 'src/app/shared/services/common-data-sharing.service';
import { ReadNotificationComponent } from 'src/app/components/notifications/popups/read-notification/read-notification.component';
@Component({
  selector: 'app-notification-listing',
  templateUrl: './notification-listing.component.html',
  styleUrl: './notification-listing.component.scss'
})
export class NotificationListingComponent implements OnInit {
  @Input() notificationLists: any = [];
  @Input() usedFor:any;

  constructor(private _router: Router, private _commonDataSharing: CommonDataSharingService,private _toastr: ToastrService, private _ngbModal: NgbModal, private _apiCalls: ApiCallsService, private _activatedRoute: ActivatedRoute) { }

  ngOnInit(): void { }

  actionPopup(type: any, notification: any): void {
    let modalRef = this._ngbModal.open(ConfirmationPopupComponent, { backdrop: 'static', keyboard: false, size: "small confirmationPopup" });
    modalRef.componentInstance.confirmationMessage = (type == 'approve' ? confirmationMessages.approveEditRequest : confirmationMessages.declineEditRequest);
    modalRef.result.then((res: any) => {
      if (res) {
        const request = {'id': notification.id, 'businessUserAssignedId': notification.businessUserAssignedId };
        this._apiCalls.post(type == 'approve' ? api._approveEditReq : api._declineEditReq, request).subscribe({
          next: (res: any) => {
            this._toastr.success(type == 'approve' ? "Request edit has been approved successfully." : "Request edit has been declined successfully.");
            notification.showApproveEditRequest = 0;
            this._commonDataSharing.notificationHeader.next(notification.id);
          },
          error: (err: any) => console.log(err)
        });
      }
    })
  }

  openNotificationReadPopup(notification: any): void {
    let modalRef = this._ngbModal.open(ReadNotificationComponent, { backdrop: 'static', centered: true, keyboard: false, size: "lg" });
    modalRef.componentInstance.notificationData = notification;
    if(notification.isRead == 0) {
      this._commonDataSharing._markAsRead(notification.id).subscribe({
        next: (res: any) => {
          notification.isRead = 1;
          this._commonDataSharing.notificationIsRead.next(notification.id);
        },
        error: (err: any) => console.log(err)
      })
    }
  }

  redirectNotification(notification: any): void {
    if(notification.isRead == 0) {
      this._commonDataSharing._markAsRead(notification.id).subscribe({
        next: (res: any) => {
          notification.isRead = 1;
          this._commonDataSharing.notificationIsRead.next(notification.id);
        },
        error: (err: any) => console.log(err)
      })
    }  
    if((notification.type >= 1 && notification.type <= 9) || notification.type != 10 || notification.type != 14) {
      this._router.navigate(["/orders/details/" + notification.objectId]);
    }
    if(notification.type == 14) {
      this._router.navigate(["/pickup-orders/details/" + notification.objectId]);
    }
  }

  dateInMilisecond(date: any) {
    const d = new Date(date);
    const miliSecond = d.getTime();
    return miliSecond
  }
}
